import { server } from "@/api";

export const paginate = async (params) => {
    return await server().get('api/notifications', { params });
}

export const send = async (notification) => {
    return await server().post('api/notifications', notification);
}

export default { paginate, send };
